import { StaticNavigationNavigationItemDtoLinkType } from '@ori/static-api-client-react';
import React, { Suspense } from 'react';

import { useFooterContext } from '../../hooks';
import { extractFooterNavigationType } from '../../utils/extractFooterNavigationType';
import { ContentRoot } from './ContentRoot';

const LazyTurkishMarketException = React.lazy(async () =>
  import('../marketExceptions/TurkishMarketException').then((module) => ({ default: module.TurkishMarketException })),
);

export const MarketExceptions: React.FC = () => {
  const { data } = useFooterContext();

  const footer = extractFooterNavigationType(data);
  const trQr = footer?.children.some((x) => x.linkType === StaticNavigationNavigationItemDtoLinkType.QRTR);

  return trQr ? (
    <ContentRoot>
      <Suspense fallback={<div style={{ minHeight: '120px' }} />}>
        <LazyTurkishMarketException />
      </Suspense>
    </ContentRoot>
  ) : null;
};
